import CadastrarNome from "../../componentes/form/cadastrar-nome";

export default function CadastrarConcedente() {

  return <CadastrarNome label="Cadastrar concedente" labelListagem="Concedentes" url="/concedente" />
}